import { LUMINA_PLACEHOLDER_RE } from './LUMINA_PLACEHOLDER_RE';

/**
 * Splices Lumina XML payloads (from the chat store's `markdownData` map) back
 * into the `[^lumina^]` placeholders in the markdown content, in order, so
 * `luminaToAdf` can parse the full document.
 *
 * The `markdownData` map is keyed by something like `lumina-0`, `lumina-1`, …
 * with values that are the raw Lumina XML fragments (everything that was
 * between `◐` and `◑` on the wire).
 */
export const splicePlaceholders = (
	content: string,
	markdownData: Record<string, string | undefined> | undefined,
): string => {
	if (!markdownData) {
		return content;
	}
	const luminaKeys = Object.keys(markdownData)
		.filter((k) => k.startsWith('lumina-') && !k.endsWith('-loading'))
		.sort((a, b) => {
			const ai = parseInt(a.substring('lumina-'.length), 10);
			const bi = parseInt(b.substring('lumina-'.length), 10);
			return ai - bi;
		});
	if (luminaKeys.length === 0) {
		return content;
	}

	let i = 0;
	return content.replace(LUMINA_PLACEHOLDER_RE, () => {
		const key = luminaKeys[i++];
		if (!key) {
			return '';
		}
		const xml = markdownData[key] ?? '';
		return xml;
	});
};
